var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9766 26.0469C19.9766 24.7188 19.5078 23.7031 18.5703 23C17.6328 22.2812 15.9453 21.5312 13.5078 20.75C11.0703 19.9531 9.14062 19.1719 7.71875 18.4062C3.84375 16.3125 1.90625 13.4922 1.90625 9.94531C1.90625 8.10156 2.42188 6.46094 3.45312 5.02344C4.5 3.57031 5.99219 2.4375 7.92969 1.625C9.88281 0.8125 12.0703 0.40625 14.4922 0.40625C16.9297 0.40625 19.1016 0.851562 21.0078 1.74219C22.9141 2.61719 24.3906 3.85937 25.4375 5.46875C26.5 7.07812 27.0312 8.90625 27.0312 10.9531H20C20 9.39062 19.5078 8.17969 18.5234 7.32031C17.5391 6.44531 16.1562 6.00781 14.375 6.00781C12.6562 6.00781 11.3203 6.375 10.3672 7.10938C9.41406 7.82812 8.9375 8.78125 8.9375 9.96875C8.9375 11.0781 9.49219 12.0078 10.6016 12.7578C11.7266 13.5078 13.375 14.2109 15.5469 14.8672C19.5469 16.0703 22.4609 17.5625 24.2891 19.3438C26.1172 21.125 27.0312 23.3438 27.0312 26C27.0312 28.9531 25.9141 31.2734 23.6797 32.9609C21.4453 34.6328 18.4375 35.4688 14.6562 35.4688C12.0312 35.4688 9.64062 34.9922 7.48438 34.0391C5.32812 33.0703 3.67969 31.75 2.53906 30.0781C1.41406 28.4062 0.851562 26.4688 0.851562 24.2656H7.90625C7.90625 28.0312 10.1562 29.9141 14.6562 29.9141C16.3281 29.9141 17.6328 29.5781 18.5703 28.9062C19.5078 28.2188 19.9766 27.2656 19.9766 26.0469Z",
    fill: "url(#paint0_linear_6_100)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_100",
    x1: 13.9414,
    y1: 0.40625,
    x2: 13.9414,
    y2: 35.4688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A9AE3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS);
export default __webpack_public_path__ + "static/media/S.4a6db7a99090a8db44f49e44b267851c.svg";
export { ForwardRef as ReactComponent };